import styled from 'styled-components';

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
`;

export const MapIframe = styled.iframe<{
  isLoading: boolean;
  isViewOnlyMode: boolean;
}>`
  width: ${({ isLoading }) => (isLoading ? '0' : '100%')};
  height: ${({ isLoading }) => (isLoading ? '0' : '100%')};
  border: 0;
  ${({ isViewOnlyMode }) => isViewOnlyMode && 'pointer-events: none;'}
`;
